import http from "../helpers/http-common"

class TicketsDataService {

    getList(params) {
        return http.post(`/tickets/list`, params)
    }

    getStats(params) {
        return http.post(`/tickets/stats`, params)
    }

    review(ticketId, params) {
        return http.post(`/tickets/${ticketId}/review`, params)
    }

    reopen(ticketId, params) {
        return http.post(`/tickets/${ticketId}/reopen`, params);
    }

    close(ticketId, params) {
        return http.post(`/tickets/${ticketId}/close`, params)
    }

    sendReply(ticketId, params) {
        return http.post(`/tickets/${ticketId}/reply`, params)
    }
}

export default new TicketsDataService();